/* eslint-disable */
// @ts-nocheck

import { rootHeaderNavigation } from '../roots';

function preciseOuterWidth(element, includeMargin = false) {
	if (!element) return 0;

	const rect = element.getBoundingClientRect();
	let width = rect.width; // This gives the precise width with sub-pixel accuracy

	if (includeMargin) {
		const style = window.getComputedStyle(element);
		const marginLeft = parseFloat(style.marginLeft) || 0;
		const marginRight = parseFloat(style.marginRight) || 0;
		width += marginLeft + marginRight;
	}

	return width;
}

function getInnerContentWidth(element) {
	const style = window.getComputedStyle(element);
	const paddingLeft = parseFloat(style.paddingLeft) || 0;
	const paddingRight = parseFloat(style.paddingRight) || 0;

	return element.clientWidth - paddingLeft - paddingRight;
}

function getHiddenElementWidth(element, includeMargin = false) {
	// Store the original styles
	const originalStyle = {
		display: element.style.display,
		visibility: element.style.visibility,
		position: element.style.position,
	};

	// Temporarily make the element visible
	element.style.visibility = 'hidden';
	element.style.display = 'block';
	element.style.position = 'absolute';

	// Measure the width
	const width = includeMargin ? preciseOuterWidth(element, true) : element.offsetWidth;

	// Revert the styles back to the original
	element.style.display = originalStyle.display;
	element.style.visibility = originalStyle.visibility;
	element.style.position = originalStyle.position;

	return width;
}

function _resizeNavBar() {
	const navbar = document.querySelector('header > .nav-bar');
	if (!navbar) {
		return;
	}

	const navmain = navbar.querySelector('.nav-main');
	if (!navmain) {
		return;
	}

	const hiddenNavRoot = navbar.querySelector('.hidden-nav');
	const hiddenNav = hiddenNavRoot?.querySelector('ul');

	if (!hiddenNavRoot || !hiddenNav) {
		return;
	}

	const navitems = Array.from(
		navmain.querySelectorAll('li:not(.hidden-nav):not(.hidden-nav li)'),
	);
	const logo = navbar.querySelector('a.account-logo');

	// At very small screen sizes, collapse all nav items into the dropdown
	if (window.innerWidth < 450) {
		navitems.forEach((item) => {
			hiddenNav.appendChild(item);
		});
		hiddenNavRoot.style.display = hiddenNav.children.length ? 'block' : 'none';
		return;
	}

	const containerWidth = getInnerContentWidth(navbar) || 0;
	const logoWidth = preciseOuterWidth(logo) || 100;
	const ctaWidth = preciseOuterWidth(navbar.querySelector('.cta-main-container')) || 0;
	const dropdownWidth = getHiddenElementWidth(hiddenNavRoot, true) || 0;

	let counted = false;
	let navWidth = 0;

	let actualWidth = containerWidth - logoWidth - ctaWidth - dropdownWidth;

	if (logo) {
		const logoStyle = window.getComputedStyle(logo);
		if (
			logoStyle.position === 'absolute' ||
			(logoStyle.position === 'relative' && logoStyle.float === 'none')
		) {
			actualWidth += logo.offsetWidth || 0;
		}
	}

	const navmainStyle = window.getComputedStyle(navmain);
	const navmainOuterWidth =
		navmain.offsetWidth +
		parseFloat(navmainStyle.marginLeft) +
		parseFloat(navmainStyle.marginRight);
	const navmainWidth = getInnerContentWidth(navmain);

	// Consider navItems container padding / margin
	if (navmainOuterWidth - navmainWidth > 0) {
		actualWidth -= navmainOuterWidth - navmainWidth;
	}

	const hiddenNavLink = hiddenNavRoot.querySelector('a');
	if (hiddenNavLink) {
		hiddenNavLink.addEventListener('click', (e) => {
			e.preventDefault();
		});
	}

	hiddenNav.style.display = 'block';

	// Add extra items to the dropdown
	navitems.forEach((item, index) => {
		item.dataset.index = index;
		navWidth += item.offsetWidth || 0;

		if (navWidth >= actualWidth) {
			hiddenNav.appendChild(item);
		}
	});

	Array.from(hiddenNav.querySelectorAll('li')).forEach((item) => {
		if (!counted) {
			navWidth += item.offsetWidth || 0;
			counted = true;
		}

		if (navWidth < actualWidth && parseInt(item.dataset.index, 10) === navitems.length) {
			hiddenNavRoot.parentNode.insertBefore(item, hiddenNavRoot);
			counted = false;
		}
	});

	if (hiddenNav.children.length) {
		hiddenNavRoot.style.display = 'block';
	} else {
		hiddenNavRoot.style.display = 'none';
	}

	// Finally, remove the single item dropdown if the item fits the space
	if (hiddenNav.children.length === 1) {
		if (navWidth - dropdownWidth < actualWidth) {
			navmain.appendChild(hiddenNav.children[0]);
			hiddenNavRoot.style.display = 'none';
		}
	}

	hiddenNav.style.display = '';
}

export function resizeNavBar() {
	_resizeNavBar();

	// To prevent flickering the div container, overflow was set to 'hidden' before mounting.
	const root = document.querySelector(rootHeaderNavigation);
	if (root) {
		root.style.setProperty('overflow', 'unset');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	'use strict';

	window.addEventListener('resize', () => {
		_resizeNavBar();
	});
});
